<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :name="name"
      :options="cursos || []"
      :data-vv-as="label"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CursoService from "../../../../domain/corpore/CursoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-cursos-pos",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    login: {
      type: String,
      default: ""
    }
  },
  asyncComputed: {
    cursos() {
      const cursoService = new CursoService(this.$http);
      return cursoService
        .getCursosPos()
        .then(res =>
          res.result.map(curso => ({
            value: curso.CODCURSO,
            text: curso.NOME
          }))
        )
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/CursosPos.vue